import React from "react";
import { Media, Texts, Title, Button } from "../../Object";
import { Grid, Space } from "../../Layout";
import Nav from "./Nav";
import { Link } from "react-router-dom";

const Footer = () => {
  const args = {
    nav: {
      remove: [],
      position: 'footer',
    },
  }

  return (
    <>
      <FixContact />
      <footer className="l-footer__wrap">
        <Link to="/">
          <Media
            src="common/icon-logo-fv"
            alt="高橋産業"
            class="c-fv__img--logo l-footer__img--logo"
          ></Media>
        </Link>
        <Nav {...args.nav}></Nav>
      </footer>
    </>
  );
};

const FixContact = () => {
  return (
    <div className="l-footer__wrap--fix">
      <Link to="tel:0724626872">
        <Media
          src="common/fix-call"
          class="l-footer__wrap--fix__media"
          alt="0724626872"
        ></Media>
      </Link>
      <Link to="/contact">
        <Media
          state="mail"
          src="common/fix-mail"
          class="l-footer__wrap--fix__media"
          alt="お問い合わせフォーム"
        ></Media>
      </Link>
    </div>
  );
};

export const Banner = () => {
  return (
    <>
      <Space size={["216px 0 0", "160px 0 0"]}>
        <div className="l-footer__wrap--banner">
          <div className="l-footer__inner--banner">
            <Title slug="contact" type="white-center"></Title>
            <Space size={["32px 0 48px", "24px 0 32px"]}>
              <Texts
                class="c-text--white c-text--center c-text--bold"
                slug="contact-banner/contact-body"
              ></Texts>
            </Space>
            <ContactButtons></ContactButtons>
          </div>
          <div className="l-footer__inner--banner" data-state="right">
            <Title slug="about-banner" type="white-center"></Title>
            <Space size={["32px 0 48px", "24px 0 32px"]}>
              <Texts
                class="c-text--white c-text--center c-text--bold"
                slug="contact-banner/about-body"
              ></Texts>
            </Space>
            <AboutButton />
          </div>
        </div>
      </Space>
    </>
  );
};

export const AboutButton = () => {
  return (
    <>
      <Space size={["0 auto"]}>
        <Button link="/about/" slug="about" type="line-white"></Button>
      </Space>
    </>
  );
};

export const ContactButtons = () => {
  return (
    <>
      <div className="c-grid__wrap--button">
        <div className="c-grid__wrap--button__inner">
          <Button slug="contact" link="/contact/" type="accent"></Button>
        </div>
        <div className="c-grid__wrap--button__inner">
          <Button slug="number" link="tel:0649677434" type="white"></Button>
          <Texts
            slug="contact/time"
            class="c-text--white c-text--bold c-text--center"
          ></Texts>
        </div>
      </div>
    </>
  );
};

export default Footer;
